var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { CircularProgress, Grid } from '@mui/material';
import { CustomInputForm } from '../../../../components/Forms/CustomInputForm';
import { MascaraDocumento } from '../../../utils/MascaraDocumento';
import { isValidCnpj } from '../../../utils/documentoValidators';
import { handleValidCnpj } from '../../../utils/validations/ValidCnpjForm';
import { MascaraCelular } from '../../../utils/MascaraTelefone';
import { handleValidEmail } from '../../../utils/validations/ValidEmailForm';
import { RequerentePj } from '../../../../model/RequerentePj';
import { PessoaJuridicaApi } from '../../../../apis/pessoaJuridicaApi';
import { DefaultCard } from '../../../../components/DefaultCard';
import { RequerentePf } from '../../../../model/RequerentePf';
import { SexoEnum } from '../../../../model/enums/SexoEnum';
export var DadosRequerentePj = function (_a) {
    // region Constants
    var _b, _c, _d, _e;
    var requerentePj = _a.requerentePj, setRequerentePj = _a.setRequerentePj, fieldsErrors = _a.fieldsErrors, handleFieldChange = _a.handleFieldChange, fieldErrorChange = _a.fieldErrorChange;
    var _f = useState(false), cnpjValid = _f[0], setCnpjValid = _f[1];
    var _g = useState(false), loadingCnpj = _g[0], setLoadingCnpj = _g[1];
    var defaultPj = function (cnpj) {
        var representante = __assign(__assign({}, new RequerentePf()), { sexo: SexoEnum.MASCULINO });
        return __assign(__assign({}, new RequerentePj()), { cnpj: cnpj, representante: representante });
    };
    // endregion
    // region Hooks
    // endregion
    // region Handlers
    var onBlurCnpj = function () { return __awaiter(void 0, void 0, Promise, function () {
        var cnpjSemForm, dados, repr, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, 3, 4]);
                    if (!(requerentePj === null || requerentePj === void 0 ? void 0 : requerentePj.cnpj) || !isValidCnpj(requerentePj === null || requerentePj === void 0 ? void 0 : requerentePj.cnpj)) {
                        setRequerentePj === null || setRequerentePj === void 0 ? void 0 : setRequerentePj(__assign({}, defaultPj(requerentePj === null || requerentePj === void 0 ? void 0 : requerentePj.cnpj)));
                        return [2 /*return*/];
                    }
                    setLoadingCnpj(true);
                    cnpjSemForm = requerentePj === null || requerentePj === void 0 ? void 0 : requerentePj.cnpj.replace(/[/.-]/g, '');
                    return [4 /*yield*/, PessoaJuridicaApi.findByCnpj(cnpjSemForm).catch(function (error) {
                            var _a, _b, _c;
                            fieldErrorChange(__assign(__assign({}, fieldsErrors), { cnpjError: (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : 'Erro ao buscar registro.' }));
                            setTimeout(function () { return fieldErrorChange(__assign(__assign({}, fieldsErrors), { cnpjError: '' })); }, 5000);
                            setLoadingCnpj(false);
                        })];
                case 1:
                    dados = _d.sent();
                    if (dados) {
                        repr = __assign(__assign({}, dados === null || dados === void 0 ? void 0 : dados.representante), { sexo: (_c = (_b = dados === null || dados === void 0 ? void 0 : dados.representante) === null || _b === void 0 ? void 0 : _b.sexo) !== null && _c !== void 0 ? _c : SexoEnum.MASCULINO });
                        setRequerentePj(__assign(__assign({}, dados), { representante: repr }));
                    }
                    else {
                        setRequerentePj === null || setRequerentePj === void 0 ? void 0 : setRequerentePj(__assign({}, defaultPj(requerentePj === null || requerentePj === void 0 ? void 0 : requerentePj.cnpj)));
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 2:
                    _a = _d.sent();
                    setLoadingCnpj(false);
                    return [3 /*break*/, 4];
                case 3:
                    setLoadingCnpj(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onHandleValidateCnpj = function (event) {
        var validDoc = handleValidCnpj({
            onChange: function (value) { return setRequerentePj(__assign({}, value)); },
            fieldErrorChange: fieldErrorChange,
            fieldsErrors: fieldsErrors,
            formData: requerentePj,
            event: event,
        });
        setCnpjValid(validDoc);
    };
    // endregion
    return (_jsx(DefaultCard, __assign({ style: { background: 'transparent' }, title: '', subTitle: 'Dados Empresáriais' }, { children: _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(CustomInputForm, { helperText: fieldsErrors === null || fieldsErrors === void 0 ? void 0 : fieldsErrors.cnpjError, error: !!(fieldsErrors === null || fieldsErrors === void 0 ? void 0 : fieldsErrors.cnpjError), value: (_b = requerentePj === null || requerentePj === void 0 ? void 0 : requerentePj.cnpj) !== null && _b !== void 0 ? _b : '', onChange: onHandleValidateCnpj, InputProps: {
                            inputComponent: MascaraDocumento,
                            endAdornment: loadingCnpj && _jsx(CircularProgress, { size: 20 }),
                        }, inputProps: { tipoEsperado: 'cnpj' }, label: "CNPJ da Empresa", onBlur: onBlurCnpj, variant: "outlined", name: "cnpj", id: "cnpj", fullWidth: true, required: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(CustomInputForm, { value: (_c = requerentePj === null || requerentePj === void 0 ? void 0 : requerentePj.razaoSocial) !== null && _c !== void 0 ? _c : '', helperText: fieldsErrors === null || fieldsErrors === void 0 ? void 0 : fieldsErrors.razaoSocialError, error: !!(fieldsErrors === null || fieldsErrors === void 0 ? void 0 : fieldsErrors.razaoSocialError), label: "Raz\u00E3o Social da Empresa", onChange: handleFieldChange, disabled: !cnpjValid, variant: "outlined", name: "razaoSocial", id: "razaoSocial", required: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(CustomInputForm, { InputProps: { inputComponent: MascaraCelular }, helperText: fieldsErrors === null || fieldsErrors === void 0 ? void 0 : fieldsErrors.telefoneComercialError, error: !!(fieldsErrors === null || fieldsErrors === void 0 ? void 0 : fieldsErrors.telefoneComercialError), value: (_d = requerentePj === null || requerentePj === void 0 ? void 0 : requerentePj.telefoneComercial) !== null && _d !== void 0 ? _d : '', onChange: handleFieldChange, label: "Telefone da Empresa", name: "telefoneComercial", id: "telefoneComercial", disabled: !cnpjValid, variant: "outlined", fullWidth: true, required: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(CustomInputForm, { helperText: fieldsErrors === null || fieldsErrors === void 0 ? void 0 : fieldsErrors.emailError, error: !!(fieldsErrors === null || fieldsErrors === void 0 ? void 0 : fieldsErrors.emailError), onChange: function (event) {
                            return handleValidEmail({
                                event: event,
                                formData: requerentePj,
                                fieldsErrors: fieldsErrors,
                                onChange: function (value) { return setRequerentePj(__assign({}, value)); },
                                fieldErrorChange: fieldErrorChange,
                            });
                        }, value: (_e = requerentePj === null || requerentePj === void 0 ? void 0 : requerentePj.email) !== null && _e !== void 0 ? _e : '', label: "E-mail da Empresa", disabled: !cnpjValid, variant: "outlined", name: "email", id: "email", fullWidth: true, required: true }) }))] })) })));
};
